import { UserListPage } from '@pages/user';
import { createMeta } from '@shared/utils';

export function meta() {
  return createMeta('Пользователи', 'Управление пользователями');
}

export default UserListPage;
